/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Influencer200,
  GetApiV1Influencer401,
  GetApiV1Influencer500,
  GetApiV1InfluencerQueryParams,
  GetApiV1InfluencerQueryResponse,
} from "../../types/influencerRegistroController/GetApiV1Influencer.ts";
import { influencerListItemViewModelPaginatedResponseSchema } from "../influencerListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1InfluencerQueryParamsSchema = z.object({
  filter: z.optional(z.string()),
  active: z.optional(z.boolean()),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1InfluencerQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Influencer200Schema = z.lazy(
  () => influencerListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Influencer200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Influencer401Schema =
  z.any() as unknown as ToZod<GetApiV1Influencer401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Influencer500Schema =
  z.any() as unknown as ToZod<GetApiV1Influencer500>;

export const getApiV1InfluencerQueryResponseSchema = z.lazy(
  () => getApiV1Influencer200Schema,
) as unknown as ToZod<GetApiV1InfluencerQueryResponse>;
